import { styled } from '@mui/material/styles';
import { Typography, Box, Card } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import ProfilePicture from 'src/sections/console/profilePicture';
import NewUserForm from 'src/sections/console/form';
import { useEffect, useState } from 'react';
import { compareObjectValues } from '../utils/common';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosPostCall } from '../services/apisCall';
import { renderErrorMessage, renderSuccessMessage } from '../lib/toastMessage';
import { useSnackbar } from 'src/components/snackbar';

const MainSection = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '14px',
  // padding: '76px 12px 12px 70px',
  padding: '76px 82px 12px 140px',
  height: '100%',
  overflowY: 'scroll',
  // overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    padding: '70px 14px 14px 14px',
    height: 'auto',
  },
}));

// const Card = styled('div')(({ theme }) => ({
//     display: 'flex',
//     flexDirection: 'column',
//     borderRadius: "6px",
//     border: '1px solid',
//     overflow: 'hidden',
//     backgroundColor: theme.palette.background.paper,
//     // borderColor: theme.palette.grey[1000],
//     width: '40%',
//     [theme.breakpoints.down('sm')]: {
//         width: '100%',
//     },
// }));

const HeadingTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[1000],
  fontSize: '20px',
  fontWeight: 600,
}));

const FormSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '10px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const NewUsers = () => {
  const navigate = useNavigate();
  const [verified, setVeried] = useState(false);
  const [image, setImage] = useState(null);
  const [edit, setEdit] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  const createNewUser = async (data) => {
    try {
      setLoading(true);
      const {
        name,
        email,
        contact,
        password,
        address,
        city,
        code,
        role,
        permission,
        products,
        gender,
        maritalStatus,
        flag,
        dDate,
        optionalParameters,
        userName,
        createdBy,
        loginLimit,
        productPermissions,
        companyName,
        companyLocation,
        createdFrom,
      } = data;

      const deactivationDate = dDate ? new Date(dDate).toISOString() : null;

      const formData = new FormData();

      const dataObj = {
        name,
        email,
        password,
        mobile: contact,
        countryCode: '91',
        address,
        createdBy,
        zipcode: code,
        city,
        role,
        permission,
        products,
        gender,
        deactivationDate,
        flag,
        maritalStatus,
        forceVerify: verified,
        profileName: image?.name || '',
        optionalParameters,
        userName,
        loginLimit,
        productPermissions,
        companyName,
        companyLocation,
        createdFrom,
      };

      if (edit) {
        delete dataObj.role;
      }

      formData.append('data', JSON.stringify(dataObj));
      formData.append('profilePhoto', image);

      if (!edit) {
        const { message } = await axiosPostCall('createConsoleUser', formData);
        renderSuccessMessage(message || 'New user crated successfully');
        setLoading(false);
        navigate('/console_users');
      } else {
        if (!compareObjectValues(userDetails, dataObj)) {
          return renderErrorMessage('No thing has been changed for update.');
        }

        formData.append('userId', userDetails?.userId);
        const { message } = await axiosPostCall('updateConsoleUser', formData);
        setLoading(false);
        renderSuccessMessage(message || 'New user crated successfully');
        // enqueueSnackbar('New user crated successfully', {
        //     anchorOrigin: { vertical: 'top', horizontal: 'right' },
        //     variant: 'success',
        // });
        navigate('/console_users');
      }
    } catch (error) {
      console.log(error);
      renderErrorMessage(error?.message || 'Network error!');
      setLoading(false);
    }
  };

  useEffect(() => {
    // const permission = checkPermission()
    // if (permission !== 'l4') return navigate('/');
    const { edit = false, userDetails = {} } = location?.state || {};
    if (edit) {
      setEdit(edit);
      const { forceVerify } = userDetails;
      setVeried(forceVerify);

      setUserDetails(userDetails);
    }

    //eslint-disable-next-line
  }, []);
  return (
    <MainSection>
      {/* <ToastContainer /> */}

      <Box sx={{ width: '100%' }}>
        <HeadingTypography>{edit ? 'Update User' : 'Create new user'}</HeadingTypography>
      </Box>

      <FormSection>
        {/* <Card sx={{ maxHeight: '420px', minHeight: "420px", justifyContent: 'center' }}> */}
        <Card sx={{ maxHeight: '420px', minHeight: '420px', justifyContent: 'center' }}>
          <ProfilePicture verified={verified} setVeried={setVeried} image={image} setImage={setImage} />
        </Card>

        <Card sx={{ width: '100%' }}>
          <NewUserForm handleCreateNewUser={createNewUser} edit={edit} userDetails={userDetails} loading={loading} />
        </Card>
      </FormSection>
    </MainSection>
  );
};

export default NewUsers;
